import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import bookingService from '../services/bookingService';
import { formatCurrency } from '../utils/helpers';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalBookings: 0,
    totalRevenue: 0,
    confirmedBookings: 0,
    cancelledBookings: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const today = new Date();
        const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const analytics = await bookingService.getBookingAnalytics(startDate, endDate);
        setStats(analytics);
      } catch (error) {
        console.error('Error fetching analytics:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Admin Dashboard</h1>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
          {[
            { label: 'Total Bookings', value: stats.totalBookings, color: 'bg-blue-500' },
            { label: 'Total Revenue', value: formatCurrency(stats.totalRevenue), color: 'bg-green-500' },
            { label: 'Confirmed', value: stats.confirmedBookings, color: 'bg-yellow-500' },
            { label: 'Cancelled', value: stats.cancelledBookings, color: 'bg-red-500' },
          ].map((stat, idx) => (
            <div key={idx} className={`${stat.color} text-white p-6 rounded-lg shadow-lg`}>
              <p className="text-sm opacity-90">{stat.label}</p>
              <p className="text-3xl font-bold">{stat.value}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            { label: 'Manage Trains', icon: '\uD83D\uDE86', path: '/manage-trains' },
            { label: 'Manage Users', icon: '\uD83D\uDC65', path: '/manage-users' },
          ].map((item, idx) => (
            <Link
              key={idx}
              to={item.path}
              className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition border-l-4 border-primary"
            >
              <p className="text-3xl mb-2">{item.icon}</p>
              <p className="text-lg font-semibold">{item.label}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
